import script from "./MakeUpExamManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./MakeUpExamManagement.vue?vue&type=script&setup=true&lang=js"

import "./MakeUpExamManagement.vue?vue&type=style&index=0&id=3729068a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3729068a"]])

export default __exports__